export class MarginStyleFormatHelper {
    static _targetTexts = {
        "component": "Componente",
        "exceptions": "Exceções",
        "description": "Descrição",
        "text": "Texto",
        "schedule": "Horário",
        "stopslist": "Lista das Paragens",
        "zonesbar": "Zonas",
        "durationbar": "Duração",
        "smscode": "Código SMS",
        "stopcode": "Código da Paragem",
        "stopname": "Nome da Paragem",
        "linecode": "Código da Linha",
        "linename": "Nome da Linha",
        "qrcode": "QR Code",
        "minutes": "Minutos",
        "passings": "Passagens",
        "terminalstops": "Paragens Terminais",
        "previousstops": "Paragens Anteriores",
        "currentstop": "Paragem Alvo",
        "nextstops": "Próximas Paragens",
        "hourpassings": "Hora (tabela)",
        "minutepassings": "Minutos (tabela)",
        "insidecell": "Dentro das Células",
        "outsidecell": "Entre Células",
        "separator": "Separador",
        "maindaytype": "Tipo de Dia Principal",
        "linecolor": "Indicador Cor da Linha",
        "pointname": "Nome do Ponto",
        "secundarylinecode": "Linhas não presentes no mapa"
    }

    static getTargetTextsArray(targetsArray) {
        const output = [];
        
        for(const idx in targetsArray) {
            output.push(this._targetTexts[targetsArray[idx].toLowerCase()]);
        }

        return output;
    }

    static getTargetText(target) {
        return this._targetTexts[target.toLowerCase()];
    }
}
